import React from 'react';
import { bool } from 'prop-types';
import { DataTypeProvider } from '@devexpress/dx-react-grid';

import EditableFormatter from './EditableFormatter';

const UneditableFormatter = ({ row, value }) => {
    if (!row.isLeaf) {
        return null;
    }
    return value;
};

const InventoryLeafCellFormatter = ({ editable, ...props }) => {
    let formatterComponent = UneditableFormatter;
    if (editable) {
        formatterComponent = EditableFormatter;
    }
    return (
        <DataTypeProvider
            formatterComponent={formatterComponent}
            {...props}
        />
    );
};

InventoryLeafCellFormatter.defaultProps = {
    editable: false
};

InventoryLeafCellFormatter.propTypes = {
    editable: bool
};

export default InventoryLeafCellFormatter;
